import React, { useState, useEffect, useRef } from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import Select, { MultiValue } from 'react-select';
import Tag from '../../../interfaces/tag/Tag';
import TicketStatus from '../../../interfaces/ticket/TicketStatus';
import Sprint from '../../../interfaces/sprint/Sprint';
import { User } from '../../../interfaces/User';

interface OptionType {
    value: string;
    label: string;
}

interface IssuesFilterProps {
    show: boolean;
    onHide: () => void;
    tags: Tag[];
    statuses: TicketStatus[];
    sprints: Sprint[];
    assignableUsers: User[];
    onApplyFilters: (filters: any) => void;
}

const IssuesFilter: React.FC<IssuesFilterProps> = ({
    show,
    onHide,
    tags,
    statuses,
    sprints,
    assignableUsers,
    onApplyFilters
}) => {
    const [tempSearchTerm, setTempSearchTerm] = useState("");
    const [tempAssigneeFilter, setTempAssigneeFilter] = useState<OptionType[]>([]);
    const [tempStatusFilter, setTempStatusFilter] = useState<MultiValue<OptionType>>([]);
    const [tempTagsFilter, setTempTagsFilter] = useState<MultiValue<OptionType>>([]); // Typed correctly

    const clearFilters = () => {
        setTempSearchTerm("");
        setTempAssigneeFilter([]);
        setTempStatusFilter([]);
        setTempTagsFilter([]);
    };

    const statusOptions = statuses.map(s => ({ value: s.name, label: s.name }));
    const tagOptions = tags.map(t => ({ value: t.name, label: t.name }));

    const handleApply = () => {
        onApplyFilters({
            searchTerm: tempSearchTerm,
            assignees: tempAssigneeFilter.map(a => a.value),
            statuses: (tempStatusFilter as OptionType[]).map(s => s.value),
            tags: (tempTagsFilter as OptionType[]).map(t => t.value), // Send strings to parent
        });
        onHide();
    };

    return (
        <Offcanvas show={show} onHide={onHide} placement="end" className="my_offcanvas">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Filter Issues</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="custom_input_flled">
                    <label>Search</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder='Search title...'
                        value={tempSearchTerm}
                        onChange={(e) => setTempSearchTerm(e.target.value)}
                    />
                </div>

                <div className="custom_input_flled">
                    <label>Status</label>
                    <Select
                        isMulti
                        options={statusOptions}
                        value={tempStatusFilter}
                        onChange={(val) => setTempStatusFilter(val)}
                        classNamePrefix="react-select"
                    />
                </div>

                <div className="custom_input_flled">
                    <label>Tags</label>
                    <Select
                        isMulti
                        options={tagOptions}
                        value={tempTagsFilter} // Correctly reference the state object
                        onChange={(val) => setTempTagsFilter(val)}
                        classNamePrefix="react-select"
                    />
                </div>
            </Offcanvas.Body>
            <div className="offcanvas_form_btn_flx p-3 border-top flex gap-2">
                <Button variant="secondary" onClick={clearFilters} className="flex-1">Clear</Button>
                <Button variant="primary" onClick={handleApply} className="flex-1">Apply Filters</Button>
            </div>
        </Offcanvas>
    );
};

export default IssuesFilter;